var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('button',{on:{"click":_vm.cancelFunc}},[_vm._v("Cancelar")]),_c('button',{staticClass:"okClass",on:{"click":_vm.okFunc}},[_vm._v("Confirmar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }